import React, {useRef, useState, useEffect, useMemo} from 'react';
import {connect} from 'react-redux';
import TextInput from '../../Shared/TextInput/TextInput';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {
  GetQrCodeOrderInfo,
  SendQrCodeViaMagicLink,
  CheckEsimClientStatus,
  SendEmailRetriveQr,
  getContactCompanyList,
  saveToHistory,
  reportDWH,
} from '../PortalsBlock/portalSlice';
import {useDispatch} from 'react-redux';
import BlackBtn from '../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import Config from '../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import {reportDWHBuilder} from './reportDWH';
import {isValidILMobile, getMobileNumSeparatedByDash} from '../../../utilities/StringHelpers/StringHelpers';
import {statusTypes, pageTypes} from './constants/enums';
import errorIcon from './images/errorIcon.svg';
import successIcon from './images/successIcon.svg';
import AlertPage from 'app/Components/Block/BusinessClientEsimUpgradeBlock/steps/pages/ErrorPage/ErrorPage';
export const BusinessClientRetriveQrCode = (props) => {
  const dispatch = useDispatch();
  const initialPageType = getInitialPageType();
  const [numberStatus, setNumberStatus] = useState({});
  const [firstEmail, setFirstEmail] = useState('');
  const [secondEmail, setSecondEmail] = useState('');
  const [firstMobileInputVal, setFirstMobileInputVal] = useState('');
  const [secondMobileInputVal, setSecondMobileInputVal] = useState('');
  const [isSendBtnDisabled, setIsSendBtnDisabled] = useState(true);
  const [inputError, setInputError] = useState('');
  const [aboveBtnError, setAboveBtnError] = useState('');
  const clmIds = {ClmUuid: '', ClmId: ''};
  const [searchBtn, setSearchBtn] = useState(true);
  const [isGuest, setIsGuest] = useState(true);
  const [phoneInputVal, setPhoneInputVal] = useState('');
  const [pageType, setPageType] = useState(initialPageType);
  const [orgDetails, setOrgDetails] = useState('');
  let orgIdArr = [];

  const reDirectToSelfCare = () => {
    initialPageType === pageTypes.ESIM_UPGRADE_START
      ? EpiContext.navigateTo(Config.businessLobbyUrl)
      : EpiContext.navigateTo(Config.lobbyUrl);
  };

  const userStatus = {
    ESIM_N: (
      <>
        למנוי המבוקש אין הזמנה עבור שירות eSIM.
        <br />
        במידת הצורך ניתן לבצע הזמנה באזור האישי באתר{' '}
        <span className='selfcare-link' onClick={() => reDirectToSelfCare()}>
          &gt;&gt;
        </span>
      </>
    ),
    DIFF_ORG: 'מנוי זה אינו שייך לארגון, במידת הצורך פנה לאחראי השירות',
    GENERAL_ERR: 'מנוי זה אינו קיים, במידת הצורך פנה לאחראי השירות',
    DIFF_ORG_DETAILS: (
      <>
        המנוי אינו שייך לארגון זה, אם ברצונך לשלוח לו QR קוד, יש להתחבר מחדש לארגון <span>{orgDetails}</span>
      </>
    ),
    NOT_VALID_MOBILE_NUMBER: 'אנא הזן מספר נייד בן 10 ספרות המתחיל ב-05',
    SUBSCRIBER_IS_SUSPENDED: (
      <>
        לא ניתן לשלוח את קוד ההפעלה למנוי מושהה,
        <br />
        יש לבחור מס' מנוי אחר
      </>
    ),
    MOBILE_NUMBERS_DONT_MATCH: 'המספרים שהזנת אינם תואמים',
  };

  useEffect(() => {
    // reportDWH('SHOWPAGE', {param10: props.portalState.selectedHetPay});
  }, []);

  useEffect(() => {
    // numberStatus.isSuccess && reportDWH('EMAIL_INPUT_SHOW', {param10: props.portalState.selectedHetPay, param1: phoneInputVal});
  }, [numberStatus]);

  useEffect(() => {
    // pageType === 'error' && reportDWH('GENERAL_ERROR', {param10: props.portalState.selectedHetPay, param1: phoneInputVal});
  }, [pageType]);

  useEffect(() => {
    if (numberStatus.message !== statusTypes.SUSPENDED_THEFT_OR_LOSS) {
      return;
    }
    handleMobileInputChange();
  }, [firstMobileInputVal, secondMobileInputVal]);

  useEffect(() => {
    if (numberStatus.message === statusTypes.SUBSCRIBER_IS_ACTIVE) {
      setErrors('', '', false);
    }
  }, [numberStatus]);

  useEffect(() => {
    if (numberStatus.message !== statusTypes.ACT_CODE_ACTIVATION) {
      return;
    }
    let error = '';
    let disabled = true;

    if (!firstEmail || !secondEmail) {
      error = 'אנא הזינו כתובות מייל';
    } else if (firstEmail !== secondEmail) {
      error = 'כתובות המייל שהזנת אינן תואמות';
    } else if (!isValidEmail(firstEmail)) {
      error = 'כתובת מייל לא תקינה';
    } else {
      error = '';
      disabled = false;
    }

    if (inputError !== error) {
      setInputError(error);
    }
    if (isSendBtnDisabled !== disabled) {
      setIsSendBtnDisabled(disabled);
    }
  }, [firstEmail, secondEmail]);

  const reportDWH = (mode, params) => {
    const report = reportDWHBuilder(mode, params, props);
    props.reportDWH(report);
  };

  const checkEnteredNumber = async () => {
    reportDWH('SEARCH_CLICK', {param10: props.portalState.selectedHetPay, param1: phoneInputVal});
    props.portalState.privateCompanyList.map((item) => {
      orgIdArr.push(item.orgId);
    });
    let res = await dispatch(
      CheckEsimClientStatus({
        chosenOrgNumber: props.portalState.selectedHetPayId,
        userPhoneNumber: phoneInputVal,
        privateCompanyList: orgIdArr,
      }),
    );
    if (res?.payload?.error) {
      setPageType(pageTypes.GENERAL_ERROR);
    } else {
      setNumberStatus(res.payload);
      !res.payload.isSuccess &&
        reportDWH('NO_QR_CODE', {
          param10: props.portalState.selectedHetPay,
          param1: phoneInputVal,
          param2: userStatus[res.payload.message],
        });
    }
    if (res.payload.message === 'DIFF_ORG_DETAILS') {
      handleDifferentOrgDetails(res.payload.extra);
    }
    setSearchBtn(false);
  };

  const CloseButton = ({onClick}) => (
    <svg
      onClick={() => {
        setPhoneInputVal('');
        setSearchBtn(true);
      }}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.645 4.367a1.209 1.209 0 0 0-1.711 0L12 10.29 6.066 4.355a1.208 1.208 0 0 0-1.711 0 1.208 1.208 0 0 0 0 1.711L10.289 12l-5.934 5.934a1.209 1.209 0 0 0 0 1.711 1.209 1.209 0 0 0 1.711 0L12 13.711l5.934 5.934a1.209 1.209 0 0 0 1.711 0 1.209 1.209 0 0 0 0-1.711L13.711 12l5.934-5.934a1.216 1.216 0 0 0 0-1.699z'
        fill='var(--theme-primary, #810ea9)'
      />
    </svg>
  );

  const SearchButton = ({callbackFunc}) => (
    <svg onClick={() => callbackFunc()} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='11' cy='11' r='8' stroke='var(--theme-primary, #810ea9)' strokeWidth='2' />
      <path d='M20.293 21.707a1 1 0 0 0 1.414-1.414l-1.414 1.414zm1.414-1.414-4-4-1.414 1.414 4 4 1.414-1.414z' fill='var(--theme-primary, #810ea9)' />
    </svg>
  );

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const submitMail = async () => {
    reportDWH('SEND_BUTTON', {param10: props.portalState.selectedHetPay, param1: phoneInputVal, param2: firstEmail});

    await sendMagicLink('EsimQrCode', true, false, true, {
      phoneNumber: phoneInputVal,
      toActivate: 'N',
      email: firstEmail,
      returnUrl: '',
    });
  };

  async function sendMagicLink(scopeName, isDynamic, sendSms, sendEmail, parameters) {
    try {
      let res = await dispatch(
        SendEmailRetriveQr({
          clientName: 'CELLBUS_WEB_SITE',
          scopeName: scopeName,
          isDynamic: isDynamic,
          sendSms: sendSms,
          sendEmail: sendEmail,
          parameters: parameters,
        }),
      );
      if (res?.payload.error) {
        setPageType(pageTypes.GENERAL_ERROR);
        return;
      }
      setPageType(pageTypes.FINAL_SUCCESS_PAGE);
      var businessDetails = {
        'כתובת מייל': firstEmail,
        _subscriber: phoneInputVal,
      };
      reportDWH('SUCCESS', {
        param10: props.portalState.selectedHetPay,
        param1: phoneInputVal,
        param2: firstEmail,
        businessDetails: businessDetails,
      });
    } catch {
      setPageType(pageTypes.GENERAL_ERROR);
    }
  }

  const resetSearch = () => {
    setSecondEmail('');
    setFirstEmail('');
    setSecondMobileInputVal('');
    setFirstMobileInputVal('');
    setErrors();
    setNumberStatus({});
    setPhoneInputVal('');
    setSearchBtn(true);
    setPageType(initialPageType);
  };

  function setErrors(inputErr = '', aboveErr = '', isDisabled = true) {
    setInputError(inputErr);
    setAboveBtnError(aboveErr);
    setIsSendBtnDisabled(isDisabled);
  }

  function handleMobileInputChange() {
    if (firstMobileInputVal === '' && secondMobileInputVal === '') {
      setErrors('', '', true);
      return;
    }

    if (!isValidILMobile(firstMobileInputVal) || !isValidILMobile(secondMobileInputVal)) {
      setErrors(userStatus.NOT_VALID_MOBILE_NUMBER, '', true);
      return;
    }

    if (firstMobileInputVal !== secondMobileInputVal) {
      setErrors(userStatus.MOBILE_NUMBERS_DONT_MATCH, '', true);
      return;
    }

    if (firstMobileInputVal === phoneInputVal || secondMobileInputVal === phoneInputVal) {
      setErrors('', userStatus.SUBSCRIBER_IS_SUSPENDED, true);
      return;
    }

    setErrors('', '', false);
  }

  const handleGetQrCodeOrderInfo = async () => {
    // reportDWH('SEARCH_CLICK', {param10: props.portalState.selectedHetPay, param1: phoneInputVal});
    const res = await dispatch(
      GetQrCodeOrderInfo({
        subscriberNumber: phoneInputVal,
        contactOrgId: props.portalState.selectedHetPayId,
      }),
    );
    const {resultObj, isValid} = res.payload;
    if (!isValid) {
      analyzeErrorStatus(resultObj);
      return;
    }
    analyzeSuccessStatus(resultObj);
  };

  function analyzeErrorStatus(resultObj) {
    const {data, status, errorMessage} = resultObj;

    switch (status) {
      case statusTypes.NOT_BELONG_TO_ORG:
      case statusTypes.PROVIDER_1428_RELATED_ERROR:
        setNumberStatus({isSuccess: false, message: 'DIFF_ORG'});
        break;
      case statusTypes.BELONG_TO_DIFFERENT_ORG:
        setNumberStatus({isSuccess: false, message: 'DIFF_ORG_DETAILS'});
        handleDifferentOrgDetails(data);
        break;
      case statusTypes.SUSPENDED:
        setPageType(pageTypes.SUBSCRIBER_IS_SUSPENDED_ERROR);
        break;
      case statusTypes.ACT_CODE_NOT_EXIST:
      case statusTypes.PROVIDER_1716_RELATED_ERROR:
        setNumberStatus({isSuccess: false, message: 'ESIM_N'});
        break;
      case statusTypes.GENERAL_ERROR:
      default:
        setNumberStatus({isSuccess: false, message: 'GENERAL_ERR'});
        break;
    }
  }

  function analyzeSuccessStatus(resultObj) {
    const {data, status, errorMessage} = resultObj;

    switch (status) {
      case statusTypes.SUBSCRIBER_IS_ACTIVE:
        setNumberStatus({isSuccess: true, message: statusTypes.SUBSCRIBER_IS_ACTIVE, data: data});
        break;
      case statusTypes.SUSPENDED_THEFT_OR_LOSS:
        setNumberStatus({isSuccess: true, message: statusTypes.SUSPENDED_THEFT_OR_LOSS, data: data});
        break;
      case statusTypes.ACT_CODE_ACTIVATION:
        setNumberStatus({isSuccess: true, message: statusTypes.ACT_CODE_ACTIVATION, data: data});
        break;
      default:
        setNumberStatus({isSuccess: true});
        break;
    }
  }
  const handleDifferentOrgDetails = (orgData, orgId = props.portalState.selectedHetPayId) => {
    if (orgData && Object.values(orgData).length > 0) {
      setOrgDetails(`${orgData.orgName} - ${orgData.orgId}`.trim());
      return;
    }
    props.portalState.privateCompanyList.map((company) => {
      if (company.orgId == orgId) {
        setOrgDetails(` ${company.orgName} - ${company.idNumber}`);
      }
    });
  };

  function getInitialPageType() {
    const QR_SEND_TYPE = {
      STANDARD: 0,
      ESIM_UPGRADE: 1,
    };

    const qrSendTypeValue = props.iContent?.qrSendType?.value;

    return qrSendTypeValue === QR_SEND_TYPE.ESIM_UPGRADE ? pageTypes.ESIM_UPGRADE_START : pageTypes.START;
  }

  function validateAndProcessInput() {
    if (!isValidILMobile(phoneInputVal)) {
      setNumberStatus({isSuccess: false, message: 'NOT_VALID_MOBILE_NUMBER'});
      return;
    }
    handleGetQrCodeOrderInfo();
  }

  async function submitSubscriberNumber(otpPhone, salesOrder) {
    // reportDWH('SEND_BUTTON', {param10: props.portalState.selectedHetPay, param1: phoneInputVal, param2: otpPhone});
    const res = await dispatch(
      SendQrCodeViaMagicLink({
        subscriberNumber: phoneInputVal,
        otpPhone,
        salesOrder,
      }),
    );
    if (res.payload?.header?.returnCode !== '00') {
      setPageType(pageTypes.GENERAL_ERROR);
      return;
    }
    setPageType(pageTypes.FINAL_SUCCESS_PAGE);
  }

  function handleSuccessByStatus(status, data) {
    const salesOrder = data?.salesOrder ?? '';
    switch (status) {
      case statusTypes.SUBSCRIBER_IS_ACTIVE: {
        return renderSuccessByStatus({
          mainHeadline: `נמצא קוד QR למנוי מספר ${phoneInputVal}`,
          containerHeadline: 'מספר המנוי אליו יישלח קוד ההפעלה',
          inputObj1: {disabled: true, value: phoneInputVal, required: 'required', placeholder: 'מספר מנוי'},
          inputObj2: {disabled: true, value: phoneInputVal, required: 'required', placeholder: 'אימות מספר מנוי', error: inputError},
          btnText: 'שליחה',
          btnAction: () => submitSubscriberNumber(phoneInputVal, salesOrder),
        });
      }
      case statusTypes.SUSPENDED_THEFT_OR_LOSS: {
        const commonConstraints = {
          required: 'required',
          maxLength: '10',
          pattern: '[0-9]*',
        };

        return renderSuccessByStatus({
          mainHeadline: (
            <>
              קוד ה-QR של מנוי מספר {phoneInputVal} מושהה,
              <br />
              נוכל לשלוח את הקוד למספר אחר
            </>
          ),
          containerHeadline: 'מספר המנוי שאליו תרצו לשלוח את קוד ההפעלה',
          inputObj1: {
            onChange: (e) => setFirstMobileInputVal(e.target.value),
            placeholder: 'מספר מנוי ',
            ...commonConstraints,
          },
          inputObj2: {
            onChange: (e) => setSecondMobileInputVal(e.target.value),
            placeholder: 'אימות מספר מנוי ',
            error: inputError,
            ...commonConstraints,
          },
          aboveBtnError: aboveBtnError,
          btnText: 'שליחה',
          btnAction: () => {
            if (!isSendBtnDisabled) {
              submitSubscriberNumber(firstMobileInputVal, salesOrder);
            }
          },
        });
      }
      case statusTypes.ACT_CODE_ACTIVATION: {
        return renderSuccessByStatus({
          mainHeadline: `נמצא קוד QR למנוי מספר ${phoneInputVal}`,
          containerHeadline: 'כתובת המייל של המנוי אליו תרצו לשלוח את קוד ההפעלה',
          inputObj1: {onChange: (e) => setFirstEmail(e.target.value), required: 'required', placeholder: 'דוא"ל'},
          inputObj2: {
            onChange: (e) => setSecondEmail(e.target.value),
            required: 'required',
            placeholder: 'אימות כתובת דוא"ל',
            error: inputError,
          },
          btnText: 'שליחה',
          btnAction: () => {
            if (!isSendBtnDisabled) {
              submitMail();
            }
          },
        });
      }
      default: {
        setPageType(pageTypes.GENERAL_ERROR);
      }
    }
  }

  function getBtnContainerClass() {
    const btnDisabledClass = isSendBtnDisabled ? 'btn-disabled' : '';
    const aboveBtnErrorClass = aboveBtnError ? 'above-btn-error-exist' : '';
    return `btn-container ${btnDisabledClass} ${aboveBtnErrorClass}`;
  }

  function renderSuccessByStatus({
    mainHeadline = '',
    subHeadline = '',
    containerHeadline = '',
    inputObj1,
    inputObj2,
    btnText = '',
    btnAction,
  }) {
    return (
      <>
        <span className='result-text'>{mainHeadline}</span>
        {subHeadline && <span className='sub-headline'>{subHeadline}</span>}
        <div className='email-container'>
          <span className='msg-header'>{containerHeadline}</span>
          <TextInput {...inputObj1} onPaste={(e) => e.preventDefault()} />
          <TextInput {...inputObj2} onPaste={(e) => e.preventDefault()} />
        </div>
        {aboveBtnError && <div className='above-btn-error-message'>{aboveBtnError}</div>}
        <div className={getBtnContainerClass()}>
          <BtnSubmit onclick={btnAction} text={btnText} />
        </div>
      </>
    );
  }

  const ErrorIcon = () => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.637 8.587C5.637 4.957 8.517 2 11.99 2s6.353 2.957 6.374 6.587c0 2.196-1.059 4.109-2.541 5.217v1.63c0 .457-.381.827-.826.87l-5.824.479H9.09a.857.857 0 0 1-.593-.24c-.17-.152-.318-.39-.318-.63v-2.13c-1.694-1.196-2.541-2.979-2.541-5.196zm8.47 4.717c0-.304.149-.608.424-.76 1.334-.74 2.096-2.218 2.118-3.957 0-2.674-2.097-4.848-4.66-4.848-2.562 0-4.658 2.174-4.637 4.848 0 1.783.678 3.087 2.139 3.957a.899.899 0 0 1 .381.76v1.674l4.235-.348v-1.326z'
        fill='var(--theme-primary, #810ea9)'
      />
      <path
        d='M14.53 12.543c-.275.152-.423.456-.423.76v1.327l-4.235.347v-1.674a.899.899 0 0 0-.381-.76c-1.462-.87-2.14-2.174-2.14-3.957-.02-2.674 2.076-4.848 4.638-4.848 2.563 0 4.66 2.174 4.66 4.848-.022 1.74-.784 3.217-2.118 3.957z'
        fill='var(--theme-light,#e2cff7)'
      />
      <path
        d='m14.934 19.086-5.782.435H9.09c-.445 0-.805-.348-.847-.804a.867.867 0 0 1 .783-.935l5.781-.435a.835.835 0 0 1 .911.805.867.867 0 0 1-.783.934zM13.09 21.826 11.017 22h-.064c-.445 0-.805-.348-.847-.804a.867.867 0 0 1 .784-.935l2.096-.174a.842.842 0 0 1 .89.804.867.867 0 0 1-.784.935zM15.355 8.566c-.042.391-.36.696-.74.696h-.064a.75.75 0 0 1-.657-.826c.127-1.24-.931-1.696-1.059-1.74a.79.79 0 0 1-.444-.978c.127-.391.55-.608.931-.456.784.282 2.224 1.348 2.034 3.304z'
        fill='var(--theme-primary, #810ea9)'
      />
    </svg>
  );

  function renderErrorMessageByStatus(message = '') {
    return (
      <>
        <div className='error_msg_container'>
          <ErrorIcon />
          <span className='msg-header'>{message}</span>
        </div>
      </>
    );
  }

  function renderStartPage(mainHead = '', subHead = '', callbackFunc = () => {}) {
    return (
      <>
        <div className='header-container'>
          <div className='titles-area'>
            <span className='main-header'>{mainHead}</span>
            <span className='secondary-header'>{subHead}</span>
          </div>
          <div className={`input-container`}>
            <input
              type='text'
              value={phoneInputVal}
              className='form-control'
              placeholder='חיפוש מספר מנוי'
              onChange={(e) => {
                setPhoneInputVal(e.target.value);
                setSearchBtn(true);
              }}
            />
            {searchBtn ? <SearchButton callbackFunc={callbackFunc} /> : <CloseButton />}
          </div>
          {numberStatus.isSuccess && handleSuccessByStatus(numberStatus.message, numberStatus.data)}
          {numberStatus.isSuccess === false && renderErrorMessageByStatus(userStatus?.[numberStatus?.message])}
        </div>
        {numberStatus.isSuccess === false && (
          <BtnSubmit onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} text='חזרה לאזור האישי' />
        )}
      </>
    );
  }

  function renderPageByType() {
    switch (pageType) {
      case pageTypes.START:
        return renderStartPage('שליחת קוד QR', 'באפשרותך לחפש לפי מספר מנוי', checkEnteredNumber);
      case pageTypes.ESIM_UPGRADE_START:
        return renderStartPage('חיפוש קוד QR ', 'באפשרותך לחפש לפי מספר מנוי', validateAndProcessInput);
      case pageTypes.SUBSCRIBER_IS_SUSPENDED_ERROR:
        return (
          <AlertPage
            icon={errorIcon}
            title={`מנוי מספר ${getMobileNumSeparatedByDash(phoneInputVal)} מושהה`}
            subtitle={
              <>
                לא ניתן לבצע את הפעולה, יש לפנות
                <br />
                לאחראי/ת השירות בארגון
              </>
            }
            btn={<BtnWhiteBlackBorderBigSize text={'חזרה לאזור האישי'} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />}
          />
        );
      case pageTypes.FINAL_SUCCESS_PAGE:
        return (
          <AlertPage
            icon={successIcon}
            title={
              <>
                קודי הפעלה נשלחו למנוי
                <br />
                {getMobileNumSeparatedByDash(phoneInputVal)}
              </>
            }
            subtitle={firstEmail}
            btn={<BtnWhiteBlackBorderBigSize text='לחיפוש קוד QR נוסף' onclick={() => resetSearch()} />}
          />
        );
      case pageTypes.GENERAL_ERROR:
      default:
        return (
          <AlertPage
            icon={errorIcon}
            title={
              <>
                מצטערים, משהו השתבש בתהליך
                <br />
                ולא ניתן לבצע את הפעולה שביקשת
              </>
            }
            subtitle='באפשרותך לנסות שוב או לפנות לאחראי השירות'
            btn={<BtnWhiteBlackBorderBigSize text='חזרה לאזור האישי' onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />}
          />
        );
    }
  }

  return <div className='retrive-qr-page'>{renderPageByType()}</div>;
};

const mapStateToProps = (state) => ({
  portalState: state.portalsBlock,
});

const mapDispatchToProps = {
  CheckEsimClientStatus,
  saveToHistory,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessClientRetriveQrCode);
